import { render } from "./NCounter.vue?vue&type=template&id=28dbafaf&ts=true"
import script from "./NCounter.vue?vue&type=script&lang=ts"
export * from "./NCounter.vue?vue&type=script&lang=ts"

import "./NCounter.vue?vue&type=style&index=0&id=28dbafaf&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__